import React from 'react';
import { FaLayerGroup, FaBook, FaBoxOpen } from 'react-icons/fa';
import { useTranslation } from '../../../shared/i18n';
import { GameHero, GameSection, ProductPriceCard, FAQAccordion, GallerySwiper, Footer } from '../../../shared/components';

// images
import titulo from '../../../assets/bibliquien/Titulo.webp';
import productImage1 from '../../../assets/bibliquien/producto/producto-1.webp';
import productImage2 from '../../../assets/bibliquien/producto/producto-2.webp';
import productImage3 from '../../../assets/bibliquien/producto/producto-3.webp';
import productImage4 from '../../../assets/bibliquien/producto/producto-4.webp';
import productImage5 from '../../../assets/bibliquien/producto/producto-5.webp';
import productImage6 from '../../../assets/bibliquien/producto/producto-6.webp';
import productImage7 from '../../../assets/bibliquien/producto/producto-7.webp';
import productImage8 from '../../../assets/bibliquien/producto/producto-8.webp';
import productImage9 from '../../../assets/bibliquien/producto/producto-9.webp';
import productImage10 from '../../../assets/bibliquien/producto/producto-10.webp';

import * as S from './BibliQuienProductPage.styles';

const BibliQuienProductPage = () => {
  const t = useTranslation();

  const heroBadges = [
    { label: t('bibliquienProduct.badges.type'), variant: 'secondary' },
    { label: t('bibliquienProduct.badges.status'), variant: 'primary' },
  ];

  const galleryImages = [
    { src: productImage1, alt: t('bibliquienProduct.gallery.item1') },
    { src: productImage2, alt: t('bibliquienProduct.gallery.item2') },
    { src: productImage3, alt: t('bibliquienProduct.gallery.item3') },
    { src: productImage4, alt: t('bibliquienProduct.gallery.item4') },
    { src: productImage5, alt: t('bibliquienProduct.gallery.item5') },
    { src: productImage6, alt: t('bibliquienProduct.gallery.item6') },
    { src: productImage7, alt: t('bibliquienProduct.gallery.item7') },
    { src: productImage8, alt: t('bibliquienProduct.gallery.item8') },
    { src: productImage9, alt: t('bibliquienProduct.gallery.item9') },
    { src: productImage10, alt: t('bibliquienProduct.gallery.item10') },
  ];

  const includesItems = [
    { icon: <FaLayerGroup />, text: t('bibliquienProduct.includes.item1') },
    { icon: <FaBook />, text: t('bibliquienProduct.includes.item2') },
    { icon: <FaBoxOpen />, text: t('bibliquienProduct.includes.item3') },
  ];

  const faqItems = t('bibliquienProduct.faq.items', { returnObjects: true }) || [];

  return (
    <S.PageContainer>
      <GameHero
        title={t('bibliquienProduct.hero.title')}
        subtitle={t('bibliquienProduct.hero.subtitle')}
        badges={heroBadges}
        image={titulo}
        imageAlt={t('bibliquienProduct.hero.imageAlt')}
      />

      {/* Commercial Price & Reservation Section */}
      <GameSection
        title={t('bibliquienProduct.price.title')}
        subtitle={t('bibliquienProduct.price.subtitle')}
      >
        <ProductPriceCard
          statusText={t('bibliquienProduct.price.statusBadge')}
          priceText={t('bibliquienProduct.price.amountText')}
          priceSubtext={t('bibliquienProduct.price.amountSubtext')}
          whatsAppUrl={`https://wa.me/59895454544?text=${encodeURIComponent(t('bibliquienProduct.price.whatsAppMessage'))}`}
          whatsAppText={t('bibliquienProduct.price.whatsAppBtn')}
          footerNote={t('bibliquienProduct.price.footerNote')}
        />
      </GameSection>

      {/* What's Included */}
      <GameSection
        title={t('bibliquienProduct.includes.title')}
        subtitle={t('bibliquienProduct.includes.subtitle')}
        background="#ffffff"
      >
        <S.IncludesGrid>
          {includesItems.map((item, idx) => (
            <S.IncludeItem key={idx}>
              {item.icon}
              <S.IncludeText>{item.text}</S.IncludeText>
            </S.IncludeItem>
          ))}
        </S.IncludesGrid>
      </GameSection>

      {/* Product Gallery */}
      <GameSection
        title={t('bibliquienProduct.gallery.title')}
        subtitle={t('bibliquienProduct.gallery.subtitle')}
      >
        <GallerySwiper images={galleryImages} />
      </GameSection>

      {/* Commercial FAQ */}
      <GameSection
        title={t('bibliquienProduct.faq.title')}
        subtitle={t('bibliquienProduct.faq.subtitle')}
        background="#ffffff"
      >
        <FAQAccordion items={Array.isArray(faqItems) ? faqItems : []} />
      </GameSection>

      <Footer />
    </S.PageContainer>
  );
};

export default BibliQuienProductPage;
